import { render, staticRenderFns } from "./PixView.vue?vue&type=template&id=56686fab&scoped=true&"
import script from "./PixView.vue?vue&type=script&lang=js&"
export * from "./PixView.vue?vue&type=script&lang=js&"
import style0 from "./PixView.vue?vue&type=style&index=0&id=56686fab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56686fab",
  null
  
)

export default component.exports